import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useMemo } from 'react';
import { fetchProductTypeReguls, selectProductTypeReguls } from 'features/products/store/product-type-regul.slice';
import { QueryParams } from 'shared/types';
import { useRequestQuery } from '../../../shared/hooks/useRequest';
import { productTypeRegulService } from '../services';
import { PriceType, ProductTypeRegul } from '../models';

export const useProductTypeRegulsQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query };

    return [queryParams];
  }, []);
};

export const useProductTypeReguls = (query: QueryParams) => {
  return useFetchByParams<PriceType[]>({
    action: fetchProductTypeReguls,
    dataSelector: selectProductTypeReguls,
    params: query,
  });
};

export const useProductTypeRegulRequest = (initialParams?: QueryParams) => {
  const action = async (params?: QueryParams): Promise<ProductTypeRegul[]> => {
    if (params && ('productId[]' in params || params.productId)) {
      const response = await productTypeRegulService.getProductTypeRegul({ ...params });
      return response.rows;
    }
    return [];
  };

  return useRequestQuery<QueryParams, ProductTypeRegul[]>({
    action: action,
    defaultValue: [],
    params: initialParams,
    autoFetch: true,
  });
};
